import React from 'react'
import { useSelector } from 'react-redux'
import { SupportedBrands } from 'src/enums'
import { selectBrandName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface BrandMarkLogoIconProps {
  size: number
  knockout?: boolean
}

export const BrandMarkLogoIcon: React.FC<BrandMarkLogoIconProps> = (props) => {
  const brandName = useSelector(selectBrandName)
  const isJPM = brandName === SupportedBrands.Jpm

  return (
    <div
      css={css`
        border-radius: 50%;
        width: ${props.size}px;
        height: ${props.size}px;
        background-color: $color-white;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: clip;
      `}
    >
      <img
        src={`https://brand-assets.paywithextend.com/${brandName}/MarkLogo${props.knockout ? 'Knockout' : ''}.svg`}
        alt={''}
        css={css`
          width: ${isJPM ? props.size : props.size / 2}px;
          height: ${isJPM ? props.size : props.size / 2}px;
        `}
      />
    </div>
  )
}

export default BrandMarkLogoIcon
